export default "__VITE_ASSET__D4S67qsR__"